export const serverUrl = process.env.REACT_APP_SERVER_URL || 'http://localhost:7070/graphql'
export const alfredUrl = process.env.REACT_APP_ALFRED_URL || 'https://login.beta.theemployeeapp.com'
export const publicUrl = process.env.REACT_APP_PUBLIC_URL || 'localhost:3100'
export const riffraffUrl = process.env.REACT_APP_RIFFRAFF_URL // || if running cypress ->'riffraff.com' // if running locally -> comp ip address 'http://{computer ip address}:3030'
